import logger from '@eb/client-logger';
import {
    BarGraph,
    Bolt,
    Calendar,
    Check,
    CreditCardBack,
    Friends,
    Gear,
    Globe,
    Headphone,
    Lock,
    MagnifyingGlass,
    Megaphone,
    ScreenSmall,
    Ticket,
} from '@eb/eds-iconography';
import React from 'react';
import CtaButton from '../sharedComponents/CtaButton';
import DisclaimerText from '../sharedComponents/DisclaimerText';
import SignupForm from '../sharedComponents/SignupForm';

export const SIGNUP_URL = '/signin/signup/?referrer=%2Fcreate';

export const relativeZindexStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 100,
};

interface IconTypeDictionary {
    'bar-graph': React.ReactNode;
    bolt: React.ReactNode;
    calendar: React.ReactNode;
    check: React.ReactNode;
    'credit-card-back': React.ReactNode;
    friends: React.ReactNode;
    gear: React.ReactNode;
    globe: React.ReactNode;
    headphone: React.ReactNode;
    lock: React.ReactNode;
    'magnifying-glass': React.ReactNode;
    megaphone: React.ReactNode;
    'screen-small': React.ReactNode;
    ticket: React.ReactNode;
}

const ICON_TYPE_MAPPING: IconTypeDictionary = {
    'bar-graph': <BarGraph />,
    bolt: <Bolt />,
    calendar: <Calendar />,
    check: <Check />,
    'credit-card-back': <CreditCardBack />,
    friends: <Friends />,
    gear: <Gear />,
    globe: <Globe />,
    headphone: <Headphone />,
    lock: <Lock />,
    'magnifying-glass': <MagnifyingGlass />,
    megaphone: <Megaphone />,
    'screen-small': <ScreenSmall />,
    ticket: <Ticket />,
};

export const getIconType = (iconType: string) => {
    if (!ICON_TYPE_MAPPING.hasOwnProperty(iconType)) {
        logger.warn('Unrecognized icon type passed in', { iconType });
        return ICON_TYPE_MAPPING['magnifying-glass'];
    }
    return ICON_TYPE_MAPPING[iconType as keyof IconTypeDictionary];
};

interface CtaSigninSectionProps {
    shouldIncludeSigninFields: boolean;
    signupGridClasses: string;
    inputFieldClasses?: string;
    showMktgFormClass: boolean;
    buttonText: string;
}
export class CtaSigninSection extends React.PureComponent<
    CtaSigninSectionProps
> {
    render() {
        const {
            shouldIncludeSigninFields,
            signupGridClasses,
            inputFieldClasses,
            showMktgFormClass,
            buttonText,
        } = this.props;
        return (
            <React.Fragment>
                {shouldIncludeSigninFields && (
                    <React.Fragment>
                        <SignupForm
                            buttonText={buttonText}
                            signupGridClasses={signupGridClasses}
                            inputFieldClasses={inputFieldClasses}
                            showMktgFormClass={showMktgFormClass}
                        />
                        <DisclaimerText buttonText={buttonText} />
                    </React.Fragment>
                )}
                {!shouldIncludeSigninFields && (
                    <CtaButton
                        buttonText={buttonText}
                        buttonUrl={SIGNUP_URL}
                        buttonClasses={'eds-align--center'}
                    />
                )}
            </React.Fragment>
        );
    }
}
